import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
  currentLanguage: string = 'en';
  isDropdownOpen: boolean = false;

  @ViewChild('dropdownMenu', { static: false }) dropdownMenu?: ElementRef;

  languages = [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' }
  ];

  constructor(
    private translateService: TranslateService,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    // Get the current language from the translate service or localStorage
    const savedLanguage = localStorage.getItem('selectedLanguage');
    this.currentLanguage = savedLanguage || this.translateService.currentLang || 'en';
    this.translateService.use(this.currentLanguage);
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    
    if (this.isDropdownOpen) {
      setTimeout(() => {
        this.positionDropdown();
      });
    }
  }

  positionDropdown(): void {
    const button = this.elementRef.nativeElement.querySelector('.language-btn');
    const dropdown = this.elementRef.nativeElement.querySelector('.language-dropdown');
    
    if (button && dropdown) {
      const rect = button.getBoundingClientRect();
      const dropdownHeight = dropdown.offsetHeight;
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      
      // Position horizontally aligned with button
      dropdown.style.left = rect.left + 'px';
      
      // Position vertically - below if enough space, otherwise above
      if (spaceBelow >= dropdownHeight + 10) {
        dropdown.style.top = (rect.bottom + 4) + 'px';
        dropdown.style.bottom = 'auto';
      } else if (spaceAbove >= dropdownHeight + 10) {
        dropdown.style.bottom = (window.innerHeight - rect.top + 4) + 'px';
        dropdown.style.top = 'auto';
      } else {
        // Not enough space either way, position below and let it scroll
        dropdown.style.top = (rect.bottom + 4) + 'px';
        dropdown.style.bottom = 'auto';
      }
    }
  }

  selectLanguage(languageCode: string): void {
    this.currentLanguage = languageCode;
    this.translateService.use(languageCode);
    localStorage.setItem('selectedLanguage', languageCode);
    this.isDropdownOpen = false;
  }

  getCurrentLanguage() {
    return this.languages.find(lang => lang.code === this.currentLanguage);
  }
}
